// extracted by mini-css-extract-plugin
export default {"mascot":"Mascot_mascot__HwfHn"};